mutation DELETE_FACILITY ($id: UUID!) {
  deleteFacility(id: $id) {
    success
    error
  }
}
